import { useState } from "react";
import { IResponseApiFluent, codigosRespuesta } from "../../../Interfaces/base/IResponse";
import { IPanelHazardConfirmacion } from "./PanelHazardConfirmacion";
import { HazardService } from "../../../services/hazard/hazardService";

export const UsePanelHazardConfirmacion=(props:IPanelHazardConfirmacion)=>{
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const Registrar=()=>{
        setLoading(true)
        HazardService.RegistrarFormulario(props.request).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setLoading(false)
                setMensaje(res.data.mensaje);
                setTimeout(()=>{
                    props.reload?.();
                    reset()
                },3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    const reset=()=>{
        setMensaje("")
        setStatus(0)
        setLoading(false)
        props.onDismiss()
    }
    return {status,mensaje,loading,Registrar,reset}
}